__turbopack_context__.v({
  "carouselContainer": "MobileHero-module-scss-module__k_ki4a__carouselContainer",
  "heroContainer": "MobileHero-module-scss-module__k_ki4a__heroContainer",
  "heroContent": "MobileHero-module-scss-module__k_ki4a__heroContent",
});
